import { request } from '../../request';
import { Shift } from '@libs/models/shifts/shift';

export async function getSingleShift(shiftId: string): Promise<Shift> {
  const resp = await request.get<ShiftResponse>(`/v2/shifts/${shiftId}`);

  return {
    ...resp.data,
    externalId: resp.data.externalIdAsString,
    nurseQualifications: resp.data.staffNurseQualificationFilters,
    otherQualifications: resp.data.staffOtherQualificationFilters,
    specialty: resp.data.speciality && {
      id: resp.data.speciality.id,
      name: resp.data.speciality.title,
      category: resp.data.speciality.category,
    },
    staff: resp.data.staff
      ? {
          ...resp.data.staff,
          fullName: [resp.data.staff.firstName, resp.data.staff.lastName].filter(Boolean).join(' '),
        }
      : resp.data.assignRequest?.staff && resp.data.assignRequest?.status === 'Pending'
        ? {
            ...resp.data.assignRequest.staff,
            fullName: `${resp.data.assignRequest.staff.firstName || ''} ${resp.data.assignRequest.staff.lastName || ''}`,
            imageURL: resp.data.assignRequest.staff.imageUrl,
            nurseQualifications: [],
          }
        : null,
    startDate: resp.data.startDate.dateTime,
    endDate: resp.data.endDate.dateTime,
    timeZone: resp.data.startDate.timeZone,
    notes: resp.data.note ? [resp.data.note] : [],
    recurrence: resp.data.recurrenceType
      ? (resp.data.recurrenceType.toLowerCase() as 'single' | 'series' | 'rotation')
      : resp.data.shiftRotationId
        ? 'rotation'
        : resp.data.shiftSeriesId
          ? 'series'
          : 'single',
    recurrenceId: resp.data.shiftRecurrenceId,
  };
}

type ShiftResponse = {
  id: string; //'shift-00000000000000000000000000';
  agenciesForShare: {
    id: string; //'staffingpartner-00000000000000000000000000';
    logoURL: string;
    name: string;
    tenantId: string;
  }[];
  assignRequest: {
    status: 'Pending' | 'Approved' | 'Declined';
    staff: {
      id: string;
      imageUrl: string;
      firstName: string;
      lastName: string;
      isInternal: true;
      agencyId: string; //'agency-00000000000000000000000000';
      agencyName: string;
      orientedRecords: [
        {
          locationId: string; //'location-00000000000000000000000000';
          oriented: 'Yes' | 'No';
        },
      ];
    };
    declineReason: string;
  };
  externalIdAsString: string;
  canHasMultipleAssignee: boolean;
  staffNurseQualificationFilters: [
    {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    },
  ];
  staffOtherQualificationFilters: [
    {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    },
  ];
  staff: {
    id: string; //'staffmember-00000000000000000000000000';
    firstName: string;
    lastName: string;
    imageURL: string;
    nurseQualifications: [
      {
        id: string;
        name: string;
        abbreviation: string;
        category: string;
      },
    ];
  };
  startDate: {
    dateTime: string; //'2025-04-13T19:52:52';
    timeZone: string;
  };
  endDate: {
    dateTime: string; //'2025-04-13T19:52:52';
    timeZone: string;
  };
  department: {
    id: string; //'departmentnode-00000000000000000000000000';
    label: string;
  };
  subDepartment: {
    id: string; //'departmentnode-00000000000000000000000000';
    label: string;
  };
  speciality: {
    id: string; //'speciality-00000000000000000000000000';
    title: string;
    category: string;
  } | null;
  tags: string[];
  note: string;
  isUrgent: boolean;
  cancellingReason: string;
  unassignReason: string;
  chosenQualifications: [
    {
      id: string;
      name: string;
      abbreviation: string;
      category: string;
    },
  ];
  status: 'Opened';
  location: {
    id: string; //'location-00000000000000000000000000';
    name: string;
  };
  staffingType: 'All' | 'Internal' | 'External';
  shiftSeriesId?: string; //'shiftseries-00000000000000000000000000';
  shiftRotationId?: string; //'shiftrotation-00000000000000000000000000';
  recurrenceType: 'Series' | 'Rotation';
  shiftRecurrenceId: string;
  isShared: boolean;
  isArchive: boolean;
};
